var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24839 7.15686C6.61617 7.15686 5.28906 8.48397 5.28906 10.1162V30.8838C5.28906 32.516 6.61617 33.8431 8.24839 33.8431H31.7486C33.3808 33.8431 34.7079 32.516 34.7079 30.8838V15.5822C34.7079 14.1204 33.6434 12.9033 32.2486 12.6651V11.2092C32.2486 9.577 30.9215 8.24989 29.2893 8.24989H18.0598L17.7766 7.78733C17.5367 7.39567 17.1104 7.15686 16.6511 7.15686H8.24839ZM7.92861 10.1162C7.92861 9.9403 8.07251 9.79641 8.24839 9.79641H15.9117L18.8731 14.632C19.113 15.0236 19.5392 15.2625 19.9985 15.2625H31.7487C31.9245 15.2625 32.0684 15.4063 32.0684 15.5822L32.0684 30.8838C32.0684 31.0597 31.9245 31.2036 31.7486 31.2036H8.24839C8.07251 31.2036 7.92861 31.0597 7.92861 30.8838V10.1162ZM19.7865 11.0693L19.6763 10.8894H29.2893C29.4652 10.8894 29.609 11.0333 29.609 11.2092V12.622H20.7373L19.7865 11.0693Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.d448015f.svg";
export { ForwardRef as ReactComponent };